/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect, useRef} from "react";
import Modal from 'react-modal';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
// reactstrap components
import NotificationAlert from "react-notification-alert";
import {  
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  textarea,  
} from "reactstrap";
import { useHistory } from 'react-router-dom';
import del from "assets/img/del.png";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
// let URL_API = "https://xs458763.xsrv.jp/api/";

let session = {};
let notificationAlert;
let imgFile = "";
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding:'0.25rem',
    width:'85%',
    maxWidth:'1000px',
    borderRadius:'15px',
    fontWeight:'bold'
  },
};

function User() {
  
  let se = JSON.parse(window.sessionStorage.getItem('sessions'));
  if(!se){
    window.location = '/';
  }
  if(session['name'] == undefined){
    session = JSON.parse(window.sessionStorage.getItem('sessions'));
  }


  notificationAlert = React.useRef(); 
  const history = useHistory();    
  const [image, setImage] = useState(require("assets/img/mike.png").default);
  const [cropData, setCropData] = useState("#");
  const [cropper, setCropper] = useState();
  const [modalIsOpen, setIsOpen]    = useState(false);

  const [name, setName] = useState(session['name']);  
  const getInputNameValue = (event)=>{    
    setName(event.target.value);     
    session['name'] = event.target.value;
    var d = JSON.parse(window.sessionStorage.getItem('sessions'));
    d['name'] = event.target.value;
    window.sessionStorage.setItem("sessions", JSON.stringify(d));    
  };
  const [nickName, setNickName] = useState(session['nickName']);  
  const getInputNickNameValue = (event)=>{    
    setNickName(event.target.value);     
    session['nickName'] = event.target.value;
    var d = JSON.parse(window.sessionStorage.getItem('sessions'));
    d['nickName'] = event.target.value;
    window.sessionStorage.setItem("sessions", JSON.stringify(d));    
  };

  let nowsex = true;
  if(session['sex'] == 0)nowsex = false;     
  const [sex, setSex] = useState(nowsex);

  const getInputSexValue = (event)=>{    
    setSex(event.target.checked);        
    let s = 0;
    if(event.target.checked == true)s = 1;   
    session['sex'] = s;  
  };

  let birthdaAry = session['birthday'] && session['birthday'] != '0000-00-00' ? session['birthday'].split("-") : ['2002','01','01'];
  // console.log(birthdaAry[0]+"-"+birthdaAry[1]+"-"+birthdaAry[2]);
  let bl = "";
  let old;
  if(birthdaAry.length > 2){
    // bl = birthdaAry[0]+"年"+birthdaAry[1]+"月"+birthdaAry[2]+"日生まれ";
    bl = birthdaAry[1]+"月"+birthdaAry[2]+"日生まれ";
    old = new Date().getFullYear() - birthdaAry[0];
  }
  const [oldLab, setOldLab] = useState(old);
  const [birthLab, setBirthLab] = useState(bl);

  const [birthday, setBirthday] = useState(birthdaAry[0]+"-"+birthdaAry[1]+"-"+birthdaAry[2]);
  const getInputBirthValue = (event)=>{
        
    setBirthday(event.target.value);
    session['birthday'] = event.target.value;
    birthdaAry = event.target.value.split("-");
    bl = birthdaAry[0]+"年"+birthdaAry[1]+"月"+birthdaAry[1]+"日生まれ";
    old = new Date().getFullYear() - birthdaAry[0];

    setOldLab(old);
    setBirthLab(bl);
  };

  const [hight, setHight] = useState(session['hight']);
  const getInputHightValue = (event)=>{    
    setHight(event.target.value);
    session['hight'] = event.target.value;  
  };

  const [weight, setWeight] = useState(session['weight']);
  const getInputWeightValue = (event)=>{    
    setWeight(event.target.value);
    session['weight'] = event.target.value;
  };

  const [school, setSchool] = useState(session['school']);
  const getInputSchoolValue = (event)=>{ 
    setSchool(event.target.value);  
    session['school'] = event.target.value;
  };

  const [grade, setGrade] = useState(session['grade']);
  const getInputGradeValue = (event)=>{    
    setGrade(event.target.value); 
    session['grade'] = event.target.value;
  };

  const [post_code, setPost] = useState(session['post_code']);
  const getInputPostValue = (event)=>{    
    setPost(event.target.value);
    session['post_code'] = event.target.value;
  };

  const [address, setAddress] = useState(session['address']);
  const getInputAddressValue = (event)=>{    
    setAddress(event.target.value);
    session['address'] = event.target.value;
  };

  // const [number, setNumber] = useState(session['number']);
  // const getInputNumberValue = (event)=>{    
  //   setNumber(event.target.value); 
  //   session['number'] = event.target.value;
  // };

  const [portfolio, setPortfolio] = useState(session['portfolio'] || '');
  const portfolioUpdateFunc = (event)=>{    
    
    setPortfolio(event.target.value); 
    session['portfolio'] = event.target.value;
    
  };

  let numberLab = ['4回','8回','12回','16回','4回','フリー'];


  // const [p_proposer, s_setProposerData] = useState([]);
  // const [p_opponent, s_setOpponentData] = useState([]);
  // const [s_preparation, s_setPreparation] =  useState([]);
  const [s_win, s_setWin] = useState([]);
  // const [s_battle, s_setBattle] = useState([]);
  // const [s_ranking, s_setRanking] = useState([]);
  const [s_winrate, s_setWinrate] = useState([]);
  const [rank, setRank] = useState(0);
  useEffect(() => {
    
    if(session === null){      
      window.location = '/';
    }

    if(Array.isArray(JSON.parse(window.sessionStorage.getItem("s_winrate"))))
      s_setWinrate(JSON.parse(window.sessionStorage.getItem("s_winrate")));
    
    axios.get(URL_API+"getWinrateAPI", {
      params: {
        sel: session['id'], 
      }
    })
    .then(function (response) {

      if(response.data.length > 0 && Array.isArray(response.data)){
        s_setWinrate(response.data);
        window.sessionStorage.setItem('s_winrate', JSON.stringify(response.data));

        let winlose = {};
        winlose["lose"] = response.data[response.data.length - 1]["lose"];
        winlose["win"] = response.data[response.data.length - 1]["win"];
        s_setWin(winlose);
        window.sessionStorage.setItem('s_win', JSON.stringify(winlose));

      }

    }); 

    axios.post(URL_API+"getPlayers", {
      params: {
        user: session['id']
      }
    })
    .then(function (response) {
      // let d = JSON.parse(response);
      window.sessionStorage.setItem('players', JSON.stringify(response.data));
      // setPlayers(response.data);
      // console.log(response);
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    ); 

    s_setWin(JSON.parse(window.sessionStorage.getItem("s_win")));

    if(s_win.win == undefined){
      s_setWin({"win":0, "lose":0});
    }

  }, []);
  // const [selectedFile, setSelectedFile] = React.useState(null);
  const inputElement = useRef();
  const [selectedFile, setSelectedFile] = useState(session['profile_photo_path']);
  const [imgFile1, setImgFile1] = useState(''); 
  
  const handleSubmit = (e) => {
    setIsOpen(true);
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  }

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      setCropData(cropper.getCroppedCanvas().toDataURL());
      setImgFile1(cropper.getCroppedCanvas().toDataURL());
      imgFile = cropper.getCroppedCanvas().toDataURL();
    }
    setIsOpen(false);
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const onSelectImage = (event) => {
    document.getElementById("photo").click();
  }

  return (

    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal">
        <div className="row col-12 px-0 mx-0 py-2 justify-content-center align-items-center border-bottom">
          クロップ画像
        </div>
        <div className="row col-12 px-0 mx-0 py-4 justify-content-center align-items-center border-bottom">
          <Cropper
            style={{ height: 300, width: "100%" }}
            zoomTo={0}
            initialAspectRatio={1}
            preview=".img-preview"
            src={image}
            viewMode={1}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            autoCropArea={1}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            onInitialized={(instance) => {
              setCropper(instance);
            }}
            guides={true}
          />
        </div>
        <div className="col-12 px-0 mx-0 d-flex justify-content-between align-items-center">
          <div
            className="img-preview"
            style={{ width: "80%", float: "left", height: "200px" }}
          />
        </div>
        <div>

          <button className="btn btn-primary" style={{ float: "right" }} onClick={getCropData}>
              クロップ画像
          </button>
        </div>
      </Modal>
      <div className="content px-0 pb-0 coach-user-content"> 
        <NotificationAlert ref={notificationAlert} />
        <Row className="px-0 mx-0">
          <Col className="colp col-12">
            <Card className="card-user mb-0">              
              <CardBody>
                <Row>
                  <Col className="col-5 col-md-3 text-right" style={{position:'relative'}} >
                    <img
                      alt="..."
                      className="avatar border-gray my-0"                      
                      src={
                        imgFile1 !='' ? imgFile1 : (selectedFile ? "https://xs458763.xsrv.jp/uploads/"+selectedFile : require("assets/img/mike.png").default)}
                      onClick = {onSelectImage}
                    />
                    <i className="fas fa-edit" style={{position: 'absolute',bottom: '0px',right: '10px'}} onClick = {onSelectImage}></i>
                    <input ref={inputElement} type="file" id="photo" style={{display:'none'}} onChange={handleSubmit}/>
                  </Col>
                  <Col className="col-7 col-md-9" >
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>                    
                      <h5 className="title" style={{marginTop : "10px"}}>{portfolio}</h5>
                    </a>                 
                  </Col>
                </Row>              
              </CardBody>              
            </Card>
          </Col>
          <Col className="colp col-12">
            <Card className="card-user mb-0">
              <CardHeader>
                <CardTitle tag="h6">プロフィール編集</CardTitle>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>                     
                    <Col className="col-12">
                      <FormGroup>
                        <label>名字 </label>
                        <Input type="text" onChange={getInputNickNameValue} value={nickName == null ? '' : nickName}/>
                      </FormGroup>
                    </Col>                     
                    <Col className="col-12">
                      <FormGroup>
                        <label>名前 </label>
                        <Input type="text" onChange={getInputNameValue} value={name == null ? '' : name}/>
                      </FormGroup>
                    </Col>                  
                    <Col className="col-12">
                      <FormGroup>
                        <label>性別</label><br/>                        
                        <div className="toggle-switch">
                          <input
                            type="checkbox"
                            className="toggle-switch-checkbox"
                            name="toggle"
                            id="toggle"
                            checked={sex}
                            onChange={getInputSexValue}
                          />
                          <label className="toggle-switch-label" htmlFor="toggle">
                            <span className="toggle-switch-inner" />
                            <span className="toggle-switch-switch" />
                          </label>
                        </div>                        
                      </FormGroup>
                    </Col>                                      
                    <Col className="col-12">
                      <FormGroup>
                        <label>生年月日</label>
                        <Input type="date" onChange={getInputBirthValue} value={birthday == null ? '' : birthday}/>
                      </FormGroup>
                    </Col>  
                  </Row>
                  <Row>
                    <Col className="col-12">
                      <FormGroup>
                        <label>学校</label>
                        <Input type="text" onChange={getInputSchoolValue} value={school == null ? '' : school}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>                    
                    <Col className="col-12">
                      <FormGroup>
                        <label>学年</label>
                        <Input type="number" onChange={getInputGradeValue} value={grade == null ? '' : grade}/>
                      </FormGroup>
                    </Col>                  
                    <Col className="col-12">
                      <FormGroup>
                        <label>郵便番号</label>
                        <Input type="text" onChange={getInputPostValue} value={post_code == null ? '' : post_code}/>
                      </FormGroup>
                    </Col>
                                    
                    <Col className="col-12">
                      <FormGroup>
                        <label>住所</label>
                        <Input type="text" onChange={getInputAddressValue} value={address == null ? '' : address}/>
                      </FormGroup>
                    </Col> 
                  </Row>
                </Form> 
              </CardBody>   
            </Card>
            <Card className="card-user mb-0">
              <CardBody>
                <Form>
                  <Row>                    
                    <Col className="px-1">
                      <FormGroup>                         
                        <textarea className="form-control" id="remark" onChange={portfolioUpdateFunc} value={portfolio} type='text'></textarea>
                      </FormGroup>
                    </Col>                                     
                  </Row>
                  <Row>                    
                    <Col className="px-1">
                      <FormGroup className="mb-0">
                        <input type="button" name="user" value="プロフィール保存" className="btn-round btn btn-primary" onClick={profileUpdateFunc}/>
                      </FormGroup>
                    </Col>                                     
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

function profileUpdateFunc() {  
  
  var registerSession = JSON.stringify(session);
  window.sessionStorage.setItem("sessions", registerSession);
 
  let preparaAry = [];

  axios.post(URL_API+"profileUpdateAPI", {
    params: {
      data: registerSession, 
      img:imgFile,
      preparation : '',
      battle : '',
      ranking : ''
    }
  })
  .then(function (response) {
    var d = JSON.parse(window.sessionStorage.getItem('sessions'));
    d['profile_photo_path'] = response.data.profile_photo_path;
    d['profile_photo_url'] = response.data.profile_photo_url;
    window.sessionStorage.setItem("sessions", JSON.stringify(d));    
    session['profile_photo_path'] = response.data.profile_photo_path;
    var color = Math.floor(Math.random() * 5 + 1);
    var type;
    switch (color) {
      case 1:
        type = "primary";
        break;
      case 2:
        type = "success";
        break;
      case 3:
        type = "danger";
        break;
      case 4:
        type = "warning";
        break;
      case 5:
        type = "info";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>
            <b>「プロフィール編集」</b>が 完了しました。
          </div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
    // if(imgFile)
    //   document.getElementById('userLogo').src = imgFile;
    // else
      document.getElementById('userLogo').src = "https://xs458763.xsrv.jp/uploads/" + response.data.profile_photo_path;
      document.getElementById('userName').text = session['name'];
  })
}
export default User;
